import React, { Component } from 'react';
// import classNames from 'classnames/bind';

class Adsense300250 extends Component {

  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  render() {
    const style = {
      textAlign: 'center',
      verticalAlign: 'middle'
    }

    return (
      <div style={style}>
        <ins className="adsbygoogle"
          style={{display:'inline-block',width:'300px',height:'250px'}}
          data-ad-client="ca-pub-1407998984163880"
          data-ad-slot="5633068152"
        ></ins>
      </div>
    );
  }
}

export default Adsense300250;